import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectDropDownComponent } from 'ngx-select-dropdown';
import { CommonService } from './../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonVariablesService } from './../common-variables.service';

@Component({
  selector: 'app-users-mapping',
  templateUrl: './users-mapping.component.html',
  styleUrls: ['./users-mapping.component.css']
})
export class UsersMappingComponent implements OnInit {
  @ViewChild(SelectDropDownComponent, { "static": false })
  ngxselectRef: SelectDropDownComponent
  constructor(private commonService: CommonService,private commonVariablesService: CommonVariablesService, private formBuilder: FormBuilder, ) { }
  allUsers: any = [];
  showSaveButton:boolean=false;
  tempAllUsers:any=[];
  addPolicyNumber = [];
  deletedPolicyNumber = [];
  allPolicyNumbersData: any = [];
  dtOptions: any = {};
  usersMappingForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  submitted = false;
  usersPolicyData: any = [];
  uniquePolicyObj: any = [];
  async ngOnInit() {
	window.localStorage.setItem('pageName','');
    this.usersMappingForm = this.formBuilder.group({
      selectUser: ['', Validators.required],
    })
    this.dtOptions = {
      dom: "ftipr",
      destroy: true,
      bSort: false
      //'order': [[0, 'asc']],
    }

    await this.onDropdownLoading();
    await this.allPolicyNumbers();
    this.showSaveButton=false
   
   
  }
  get f() { return this.usersMappingForm.controls; }
  config1: any = {
    displayKey: "email_id",
    search: true,
    height: 'auto',
    placeholder: 'select the user',
    customComparator: () => { },
    limitTo: 5,
    moreText: 'more',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'search the user',
    searchOnKey: "email_id"
  }

  /*
	* Created By : Manasa R
	* Description :To load all the users with in dropdown.
	*********************************************/
  async onDropdownLoading() {
    let url = this.commonVariablesService.baseURL + "api/v1/marine_user_management/broker_user";
    let param = {
		broker_user_type:'ClientUser',
		product: this.commonVariablesService.user_management_product
    }
    let response = await this.commonService.httpPostMethod(url, param, 'application/json', true, 'users Mapping');
    if (response.body.status == 0) {
      this.allUsers = response.body.data;
      this.tempAllUsers=this.allUsers;
    }
    else if (response.body.status != -114) {
      this.commonService.errorsmsg(response.body.txt, 'Error');
    }
  }

  /*
	* Created By : Manasa R
	* Description : get the policy numbers list .
	*********************************************/
  async allPolicyNumbers() {
    this.checkedData=[];
    this.uncheckedData=[];
    this.allPolicyNumbersData=[];
    let url = this.commonVariablesService.baseURL + "api/v1/marine_master/fetchall/policy_acl_group";
    let response = await this.commonService.httpGetMethod(url, '', true, "", 'users Mapping');
    if (response.status == 0) {
      let obj = [];
      (response.data).forEach(data => {
        if (obj[data.cust_fld_1]) {
          obj[data.cust_fld_1]["policy_no"].push(data.policy_no);
        } else {
          obj[data.cust_fld_1] = {};
          obj[data.cust_fld_1] = { "cust_fld_1": data.cust_fld_1, "policy_no": [] };
          obj[data.cust_fld_1]["policy_no"].push(data.policy_no);
        }
        /* obj[data.cust_fld_1] ? obj[data.cust_fld_1]["policy_no"].push(data.policy_no)
          : (obj[data.cust_fld_1] = {}, obj[data.cust_fld_1] = { "cust_fld_1": data.cust_fld_1, "policy_no": [] }
            , obj[data.cust_fld_1]["policy_no"].push(data.policy_no)) */ 
      });
      this.uniquePolicyObj = obj;
      for (let i in obj) {
        this.allPolicyNumbersData.push(obj[i]);
      }
      for(let i=0;i<this.allPolicyNumbersData.length;i++){
        this.allPolicyNumbersData[i]['isChecked'] = ""
       this.uncheckedData.push(this.allPolicyNumbersData[i])
       } 
      this.loadDataTable();
    }
    else if (response.status != -114) {
      this.commonService.errorsmsg(response.txt, 'Error');
    }

  }

  /*
	* Created By : Manasa R
	* Description : get the particular user policy data mapping list.
  *********************************************/
 dataTableData=[];
  checkedData=[];
  uncheckedData=[]
  async userDataWithPolicyNumbers() {
    this.addPolicyNumber = [];
    this.deletedPolicyNumber = [];
    this.usersPolicyData = [];
    $("#txt_policyNumber").val("");
    this.checkedData=[];
    this.uncheckedData=[];

    let tmpUserType = window.localStorage.getItem('userProfile');
    var getUserType = this.commonService.decryptData(tmpUserType);

    if (this.usersMappingForm.value.selectUser != undefined ) {
      if(getUserType == 'admin')
      {
        this.showSaveButton=true;
      }
      let user = (this.usersMappingForm.value.selectUser).email_id;
      let url = this.commonVariablesService.baseURL + "api/v1/marine_master/fetchall/policy_user_group";
      let param = {
        email: user
      }
      let response = await this.commonService.httpGetMethod(url, '', true, param, 'users Mapping');
      if (response.status == 0) {
       // this.dataTableData=[];
       this.checkedData=[];
  this.uncheckedData=[];
  this.usersPolicyData = [];
       if(response.data.length==0)
       {
        for(let i=0;i<this.allPolicyNumbersData.length;i++){
          this.allPolicyNumbersData[i]['isChecked'] = ""
         this.uncheckedData.push(this.allPolicyNumbersData[i])
         }  
       }
        let obj = [];
        (response.data).forEach(data => {
          // check if that array exists or not in newcars object
          if (obj[data.cust_fld_1]) {
            (obj[data.cust_fld_1]["policy_no"].push(data.policy_no));
          } else {
            obj[data.cust_fld_1] = {};
            obj[data.cust_fld_1] = { "cust_fld_1": data.cust_fld_1, "policy_no": [] };
            obj[data.cust_fld_1]["policy_no"].push(data.policy_no);
          }
          /* obj[data.cust_fld_1] ? // check if that array exists or not in newcars object
            (obj[data.cust_fld_1]["policy_no"].push(data.policy_no)) : (obj[data.cust_fld_1] = {}, obj[data.cust_fld_1] = { "cust_fld_1": data.cust_fld_1, "policy_no": [] }, obj[data.cust_fld_1]["policy_no"].push(data.policy_no)) */
        });
        for (let i in obj) {
          this.usersPolicyData.push(obj[i]);
        }
        await this.sortingData();
      }
      else if (response.status != -114) {
        this.commonService.errorsmsg(response.txt, 'Error');
      }
    }
    else{
       this.showSaveButton=false;
       for(let i=0;i<this.allPolicyNumbersData.length;i++){
       this.allPolicyNumbersData[i]['isChecked'] = ""
      this.uncheckedData.push(this.allPolicyNumbersData[i])
      }}
    this.loadDataTable();
  
  }
async sortingData()
{
  this.uncheckedData=[];
  this.checkedData=[];
  for (let i = 0; i < this.allPolicyNumbersData.length; i++) {
    if (this.usersPolicyData.length > 0) {
      let flag=0;
      for (let obj of this.usersPolicyData) {
        if (obj.cust_fld_1 == this.allPolicyNumbersData[i].cust_fld_1) {
          this.allPolicyNumbersData[i]['isChecked'] = "checked";
          this.checkedData.push(this.allPolicyNumbersData[i])
          flag=1;
          break
        }
       
      }
      if(flag==0)
      {
          this.allPolicyNumbersData[i]['isChecked'] = ""
          this.uncheckedData.push(this.allPolicyNumbersData[i])
      }
    }
    else{
      this.allPolicyNumbersData[i]['isChecked'] = ""
      this.uncheckedData.push(this.allPolicyNumbersData[i])
    }
  }

}
  /*
	* Created By : Manasa R
	* Description : loads the data with in datatable .
	*********************************************/
  async loadDataTable() {
    let dataToTable=[]
    for(let i=0;i<this.checkedData.length;i++)
    {
     dataToTable.push(this.checkedData[i])
    }
    for(let i=0;i<this.uncheckedData.length;i++)
    {
      dataToTable.push(this.uncheckedData[i])
    }
    this.dataTableData=dataToTable
    if (($.fn.dataTable.isDataTable("#table_usersMappingDatatable"))) {
      $("#table_usersMappingDatatable").DataTable().destroy();
    }

    // var table = await $("#table_usersMappingDatatable").DataTable({
    await $("#table_usersMappingDatatable").DataTable({
      data: this.dataTableData,
      "columns": [
        {
          data: null,
          render: function (data) {
            let isChecked = data['isChecked'];
            let obj = '<div class="theme-checkbox" ><span tblHead="Select"></span><span class="tblValue">'
              + '<input type="checkbox" value="" id="' + data['cust_fld_1'] + '" ' + isChecked + '></span></div>';
            return obj;
          }
        },
        {
          data: "cust_fld_1",
        }
      ],
      destroy: true,
      paging: true,
      dom: "ftipr",
      "pageLength": 50,
      "createdRow": function (row, data, rowIndex) { },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        $('td:first-child', row).unbind('change');
        $('td:first-child', row).bind('change', () => {
          self.policyIsChecked(data);
        });
        return row;
      }
    }).draw();

  }

/*
	* Created By : Manasa R
	* Description : helps to push into array when the user deleted and mapped to particular policy .
	*********************************************/
  policyIsChecked(data) {
    if ($("#" + $.escapeSelector(data.cust_fld_1)).is(":checked")) {
      this.addPolicyNumber.push(data.cust_fld_1);
      var index = this.deletedPolicyNumber.indexOf(data.cust_fld_1);
      if (index != -1) {
        this.deletedPolicyNumber.splice(index, 1);
      }
    }
    else {
      let idx = this.usersPolicyData.map(function (e) { return e.cust_fld_1; }).indexOf(data.cust_fld_1);
      if (idx != -1) {
        this.deletedPolicyNumber.push(data.cust_fld_1);
      }
      let index1 = this.addPolicyNumber.indexOf(data.cust_fld_1);
      if (index1 != -1) {
        this.addPolicyNumber.splice(index1, 1);
      }
    }
  }

  /*
	* Created By : Manasa R
	* Description : saves to back end calls both post and delete methods for mapping  particular user to polices.
	*********************************************/
  async onSave() {
    if (this.usersMappingForm.invalid) {
      this.submitted = true;
      return;
    }
    else {
      let checkedDataArr=[];
      for(let i=0;i<this.checkedData.length;i++)
      {
        checkedDataArr.push(this.checkedData[i].cust_fld_1);
      }
      var res = this.addPolicyNumber.filter( function(n) { return !this.has(n) }, new Set(checkedDataArr));
      let savedData=[];
        for(let count1=0;count1<this.allPolicyNumbersData.length;count1++)
        {
          for(let count=0;count<res.length;count++)
          {
            if(res[count]==this.allPolicyNumbersData[count1].cust_fld_1){
              for(let i=0;i<this.allPolicyNumbersData[count1].policy_no.length;i++)
              {
                let user = (this.usersMappingForm.value.selectUser).email_id;
                let userType=(this.usersMappingForm.value.selectUser).broker_user_type
                let obj={
                  "email_id": user ,
                  "policy_no":this.allPolicyNumbersData[count1].policy_no[i],
                  "user_type":userType,
                  "status": "0"
                }
                savedData.push(obj);
              }
            } 
          }
          for(let count=0;count<this.deletedPolicyNumber.length;count++)
          {
            if(this.deletedPolicyNumber[count]==this.allPolicyNumbersData[count1].cust_fld_1){
              for(let i=0;i<this.allPolicyNumbersData[count1].policy_no.length;i++)
              {
                let user = (this.usersMappingForm.value.selectUser).email_id;
                let userType = (this.usersMappingForm.value.selectUser).broker_user_type;
                let obj={
                  "email_id": user ,
                  "policy_no":this.allPolicyNumbersData[count1].policy_no[i],
                  "user_type":userType,
                  "status": "1"
                }
                savedData.push(obj);
              }
            } 
          }
        }
        let url=this.commonVariablesService.baseURL+"api/v1/marine_mp_gc_data/acl";
        let param=savedData
        let response = await (this.commonService.httpPostMethod(url, param,'', true, 'client User Setup'));
					if (response.body.status == 0) {
            this.commonService.successmsg("updated successfully", 'success');
					}
					else if (response.body.status != -114) {
            this.commonService.errorsmsg("unable to save data", 'error');
          }
     

      }
     
      this.ngxselectRef._value = [];
      this.usersPolicyData=[];
      this.tempAllUsers=[];
      $("#txt_policyNumber").val("");
      await this.allPolicyNumbers();
      this.showSaveButton=false;
     // $("#btn_save").attr("disabled","true");
     // this.usersMappingForm.setValue({selectUser:undefined})
      // this.tempAllUsers=this.allUsers;
    
  }
  loadingData()
  {
    if(this.tempAllUsers.length==0) {
      this.tempAllUsers=this.allUsers;
    }
  }
  /*
	* Created By : Manasa R
	* Description : search filter for policy number with in datatable .
	*********************************************/
  filterById() {
    let policyNumber = $("#txt_policyNumber").val().toString().toLowerCase();

    var table = $("#table_usersMappingDatatable").DataTable();
    table.search('').columns().search('').draw();
    if (policyNumber != "") {
      table.column(1).search(policyNumber).draw();
    }


  }

}
